import { StoreServiceSite } from '../../hooks/types'

export type AvailableDatesRequest = {
  dealerId: string
  serviceOptions: string | undefined
  appointmentType: string
}

export type AvailableTimeSlotRequest = {
  dealerId: string
  appointmentTypeId: number
  date: string
}

export type AvailableTimeSlotsResponse = {
  id: number
  timeSlots: TimeSlotValue[]
}

export type TimeSlotValue = {
  description: string
  timeIn: string
}

export enum ServiceOption {
  MOT = 'MOT',
  OILFILTER = 'Oil & filter change',
  STANDARD = 'Standard service',
  FULL = 'Full service',
}

enum AppointmentType {
  DROPGO = 'drop-go',
  DROPWAIT = 'drop-wait',
}

export type AvailableDatesResponse = {
  id: number
  appointmentType: AppointmentType
  datesAvailable: string[]
}[]

export type SendServicingEnquiryRequest = {
  customer: {
    firstName: string
    lastName: string
    email: string
    phoneNumber: string
    postcode: string
    contactTimePreference: string
  }
  enquiry: {
    storeName: string
    storeDisplayName?: string
    storeId: string
    serviceOptions: string[]
    appointmentType: string
    preferredDate?: string
    preferredTime?: string
    notes?: string
  }
  vehicle: {
    make: string
    model: string
    vrm: string
    vin: string
    fuelType: string
  }
  marketingPreferences?: {
    phone?: boolean
    email?: boolean
    sms?: boolean
  }
  campaignId?: string
  deviceContext?: 'web' | 'app'
}

export type ProcessedStoreServiceSite = StoreServiceSite & {
  displayName: string
  distanceInMeters: number
}

export type GetSitesResponse = {
  sites: ProcessedStoreServiceSite[]
  total: number
}

export type VehicleAgeInMonthsResponse = {
  ageOfVehicleInMonths: number
}
